// extracted by mini-css-extract-plugin
export default {"svg":"AccountButton_svg__scxxQ","container":"AccountButton_container__rwi-t"};